var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-4" },
    [
      _c("v-client-table", {
        staticClass: "card table-clients vue-custom-table",
        attrs: {
          data: _vm.getLists,
          columns: _vm.columns,
          options: _vm.options,
        },
        scopedSlots: _vm._u([
          {
            key: "name",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "clickable wide",
                        attrs: { to: _vm.segmentLink(row.listId) },
                      },
                      [
                        _c(
                          "h4",
                          { staticClass: "regular text-primary bold m-0" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(row.name) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "description",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v("\n        " + _vm._s(row.description) + "\n      "),
                ]),
              ]
            },
          },
          {
            key: "lastupdate",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  [
                    _c("refreshable-timeago", {
                      attrs: { date: row.updatedAt },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "numberemails",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v("\n        " + _vm._s(row.emailCount) + "\n      "),
                ]),
              ]
            },
          },
          {
            key: "actionbuttons",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "btn-white bold btn btn-sm w-auto text-capitalize px-4 btn-view-app",
                        attrs: { to: _vm.segmentLink(row.listId) },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("lists.viewList")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }